const koStoreAddressMapping = {
	phone: ['phoneBilling', 'buyertel', 'phone'],
	zip: ['zipBilling', 'zip'],
	address1: ['address1Billing_render', 'address1_render'],
	address2: ['address2Billing', 'address2'],
	email: ['emailBilling', 'email', 'buyeremail'],
}

export function useEmailTemplate(data) {
	$('#EmailSearch__Body').html(renderEmailTemplate(data))
}

function useThisEmail(i) {
	const addressArr = Object.values(window.addressData)
	let firstName = ''
	let lastName = ''
	for (const [key, value] of Object.entries(addressArr[i])) {
		if (window.koStore) {
			if (key === 'firstName') {
				firstName = value
			} else if (key === 'lastName') {
				lastName = value
			} else if (koStoreAddressMapping[key]) {
				for (const itemName of koStoreAddressMapping[key]) {
					if (itemName === 'phone') {
						window.iti?.setNumber(value)
					} else if (itemName === 'phoneBilling') {
						window.itiBilling?.setNumber(value)
					} else if (itemName === 'buyertel') {
						window.itiBuyerTel?.setNumber(value)
					} else {
						$(`[name=${itemName}]`).val(value)
					}
				}
			}
		} else {
			if (key === 'phone') {
				window.iti.setNumber(value)
			} else {
				$(`[name=${key}]`).val(value)
			}
		}
	}
	// debugger
	if (window.koStore) {
		$(`[name=name]`).val(`${lastName} ${firstName}`)
		$(`[name=nameBilling]`).val(`${lastName} ${firstName}`)
		$(`[name=buyername]`).val(`${lastName} ${firstName}`)
	}
	$('#emailSearchModal').modal('hide')
	console.debug(Object.entries(addressArr[i]))
}

// function fillInToState (_stateId) {
// 	const stateId = _query('[data-auto-target-id="stateId"]')
// 	for (let i = 0; i < stateId.length; i++) {
// 		const option = stateId.options[i]
// 		if (option.getAttribute('value') === _stateId) {
// 			stateId.value = option.value
// 		}
// 	}
// }

function renderEmailTemplate(data) {
	const addressArr = Object.values(data)
	// console.debug(addressArr)
	let template
	addressArr.forEach((v, i) => {
		template += `<tr>${renderEmailLine(
			v
		)}<td style='vertical-align: middle'><div class='btn hand orangeText bold' onclick='useThisEmail(${i})'>Use</div></td></tr>`
	})
	return template
}

function renderEmailLine(addressObj) {
	let template
	const sample = ['firstName', 'lastName', 'address1', 'city', 'state', 'zip']
	for (const key in addressObj) {
		if (Object.prototype.hasOwnProperty.call(addressObj, key)) {
			const content = addressObj[key]
			// console.debug(content)
			if (sample.indexOf(key) > -1) {
				template += `<td style='vertical-align: middle'><div class='EmailSearch__${key} a-center'>${content}</div></td>`
			}
		}
	}

	return template
}

export default useEmailTemplate

window.useThisEmail = useThisEmail
